import { render, staticRenderFns } from "./Nerve-photo.vue?vue&type=template&id=a0ca5438&"
import script from "./Nerve-photo.vue?vue&type=script&lang=js&"
export * from "./Nerve-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports